export var PromotionType;
(function (PromotionType) {
    PromotionType["PROMOTE"] = "promote";
    PromotionType["DEMOTE"] = "demote";
})(PromotionType || (PromotionType = {}));
